import { render } from "./PanelLeft.vue?vue&type=template&id=f01a460a&scoped=true&ts=true"
import script from "./PanelLeft.vue?vue&type=script&lang=ts"
export * from "./PanelLeft.vue?vue&type=script&lang=ts"

import "./PanelLeft.vue?vue&type=style&index=0&id=f01a460a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01a460a"]])

export default __exports__